import useGetImages from "../hooks/useGetImages";
import { useTheme } from "../context/ThemeContext";

const RestaurantInfo = ({ info, id }) => {
  const theme = useTheme();
  const { image: uri } = useGetImages("product_pictures", id, info?.URUN_KOD);

  return (
    <div className="flex-col justify-between items-center pb-4 border-b border-dashed">
      {uri && (<div className="w-full h-64 flex justify-center items-center mb-4">
        <img
          className="object-cover rounded-2xl h-full"
          src={uri}
          alt="product"
        />
      </div>)}
      <div>
        <h2 className="text-[14px] font-bold my-2">{info.URUN_ADI}</h2>
        <p className="text-xs text-gray-500">{info.URUN_ACIKLAMA}</p>
        <p className={`font-bold mt-2 ${theme.primary.text}`}>₺ {info.FIYATI}</p>
      </div>
    </div>
  );
};
export default RestaurantInfo;
